import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../reducers";

/**
 * Ф4б: в слайсе осталось только UI-состояние. Производные над данными
 * меню считает useMenu поверх TanStack — их селекторы уехали в utils.ts
 * чистыми функциями.
 */

export const selectMenu = (state: RootState) => state.menu;

export const selectSearchQuery = (state: RootState) =>
  selectMenu(state).searchQuery;

export const selectActiveFilters = (state: RootState) =>
  selectMenu(state).activeFilters;

export const selectHasActiveFilters = createSelector(
  [selectActiveFilters],
  (filters) =>
    (filters.tagsInclude?.length ?? 0) > 0 ||
    (filters.tagsExclude?.length ?? 0) > 0 ||
    filters.categoryId !== undefined ||
    filters.isActive !== true ||
    filters.sortByCategoryId !== undefined ||
    filters.sortByPrice !== undefined,
);
